import React from 'react';

import { Button, Col, Row } from 'components/bootstrap';
import useSendTelemetry from 'logic/telemetry/useSendTelemetry';
import { TELEMETRY_EVENT_TYPE } from 'telemetry/Constants';

import ForwarderSelectionList from './ForwarderSelectionList';

import { StyledSection, StyledTitle } from '../StyledWizardComponents';
import type { Forwarder } from '../../Types';

type Props = {
  forwarders?: Array<Forwarder>;
  onForwarderSelect: () => void;
  onStartForwarderClick: () => void;
};

const SelectForwarder = ({ forwarders = undefined, onForwarderSelect, onStartForwarderClick }: Props) => {
  const sendTelemetry = useSendTelemetry();

  const handleForwarderSelection = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_WIZARD_CONFIGURE_FORWARDER_SELECTED, {
      app_pathname: 'forwarder',
      app_section: 'forwarder-create',
    });

    onForwarderSelect();
  };

  return (
    <Row>
      <Col md={6}>
        <StyledTitle>Select Forwarder</StyledTitle>
        <StyledSection>
          <p>Haven&apos;t started a Forwarder yet? Click here for instructions.</p>
          <Button bsStyle="primary" onClick={onStartForwarderClick}>
            Start new Forwarder
          </Button>
        </StyledSection>

        <StyledSection>
          <p>Or select one of the recently registered Forwarders from the list:</p>
          <ForwarderSelectionList forwarders={forwarders} onForwarderSelect={handleForwarderSelection} />
        </StyledSection>
      </Col>
    </Row>
  );
};

export default SelectForwarder;
